import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constants";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";

const getUserSubscriptions = (setLoading) => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) setLoading(true);

    const res = await api("get", Constants.END_POINT.USER_SUBSCRIPTIONS);

    if (res.success) {
        dispatch({
            type: types.USER_SUBSCRIPTIONS,
            payload: { data: res.data },
        });
    }
    if (setLoading) setLoading(false);
    dispatch(hideLoaderAction());
};

const grantPremium = (payload, setLoading, onSuccess) => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) setLoading(true);

    const res = await api("post", Constants.END_POINT.GRANT_PREMIUM, payload);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        if (onSuccess) onSuccess();
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    if (setLoading) setLoading(false);
    dispatch(hideLoaderAction());
};

const addCredits = (payload, setLoading, onSuccess) => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) setLoading(true);

    const res = await api("post", Constants.END_POINT.ADD_CREDITS, payload);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        if (onSuccess) onSuccess();
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    if (setLoading) setLoading(false);
    dispatch(hideLoaderAction());
};

const decreaseCredits = (payload, setLoading, onSuccess) => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) setLoading(true);

    const res = await api("post", Constants.END_POINT.DECREASE_CREDITS, payload);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        if (onSuccess) onSuccess();
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    if (setLoading) setLoading(false);
    dispatch(hideLoaderAction());
};

export { getUserSubscriptions, grantPremium, addCredits, decreaseCredits };
